import { Button, Flex, Input, Menu, MenuButton, MenuList, MenuGroup, Text } from '@chakra-ui/react'
import { useState, useEffect } from 'react'

import NumberFormat from 'react-number-format'

const RangeFilter = ({ value, setValue, direction = 'column' }) => {
  const [selectedFrom, setSelectedFrom] = useState(0)
  const [selectedTo, setSelectedTo] = useState(0)

  const handleUpdateFromChange = (newFromValue) => {
    if (!value) {
      setValue(`${newFromValue}to-`)
      return
    }
    const stringArray = value.split('to')

    if (stringArray.length !== 2 || isNaN(parseFloat(stringArray[1]))) {
      setValue(`${newFromValue}to-`)
      return
    }
    setValue(`${newFromValue}to${stringArray[1]}`)
  }

  const handleUpdateToChange = (newToValue) => {
    if (!value) {
      setValue(`-to${newToValue}`)
      return
    }
    const stringArray = value.split('to')
    if (stringArray.length !== 2 || isNaN(parseFloat(stringArray[0]))) {
      setValue(`-to${newToValue}`)
      return
    }
    setValue(`${stringArray[0]}to${newToValue}`)
  }

  useEffect(() => {
    if (!value) {
      setSelectedFrom('')
      setSelectedTo('')
    }
    if (typeof value !== 'string') {
      return
    }

    const stringArray = value.split('to')

    if (!stringArray || stringArray.length !== 2) {
      return
    }

    setSelectedFrom(parseFloat(stringArray[0]))
    setSelectedTo(stringArray[1])
  }, [value])

  return (
    <Flex direction={direction} gap="2">
      <Flex alignItems="center" gap="1" w="100%">
        <Input
          isNumericString={true}
          as={NumberFormat}
          thousandSeparator
          decimalScale={2}
          value={selectedFrom}
          onValueChange={({ value }) => {
            if (isNaN(parseFloat(value))) {
              return
            }
            setSelectedFrom(parseFloat(value))
            handleUpdateFromChange(parseFloat(value))
            //
          }}
        />
        <Text>To</Text>
        <Input
          isNumericString={true}
          as={NumberFormat}
          thousandSeparator
          decimalScale={2}
          value={selectedTo}
          onValueChange={({ value }) => {
            if (isNaN(parseFloat(value))) {
              return
            }
            setSelectedTo(parseFloat(value))
            handleUpdateToChange(parseFloat(value))
          }}
        />
      </Flex>
    </Flex>
  )
}

export default RangeFilter
